import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { apiClient } from '../api/client';
import { useApi } from '../api/useApi';
import { AsyncBoundary } from '../components/AsyncState';
import { FairFlagButton } from '../components/FairFlagButton';
import { paths } from '../routes';

export function ArticlesPage(): ReactElement {
  const { t } = useTranslation();
  const articles = useApi(() => apiClient.getArticles());
  const items = articles.data ?? [];

  return (
    <div className="app-shell pb-12">
      <h1 className="flex items-center gap-3 py-2 text-3xl font-bold text-fog-100">
        {t('articles.title')}
        <FairFlagButton className="size-8" />
      </h1>

      <AsyncBoundary loading={articles.loading} error={articles.error} onRetry={articles.reload}>
        {items.length === 0 ? (
          <p className="mt-6 text-fog-500">{t('articles.empty')}</p>
        ) : (
          <ul className="mt-4 space-y-4">
            {items.map((article) => (
              <li key={article.id}>
                <Link
                  to={paths.article(article.id)}
                  className="card block overflow-hidden transition-colors hover:bg-ink-800"
                >
                  {article.imageUrl !== null && (
                    <img
                      src={article.imageUrl}
                      alt=""
                      loading="lazy"
                      className="aspect-[5/2] w-full object-cover"
                    />
                  )}
                  <div className="p-4">
                    {article.subtitle !== null && (
                      <p className="text-sm text-fog-500">{article.subtitle}</p>
                    )}
                    <h2 className="mt-1 font-bold text-fog-100">{article.title}</h2>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </AsyncBoundary>
    </div>
  );
}
